import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

export const getChildOffices = async (officeId) => {
  const response = await UsersApi.getChildOffices(officeId);

  return UserAdapters.toGetChildOfficesResult(response);
};
